import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import { Link } from "../util/router";
import { HomeCarousel } from "./HomeCarousel";
import PoseCard from "./PoseCard";
import StylesCard from "./StylesCards";
import { useState } from "react";
import { Card, CardContent, CardMedia, Typography } from "@material-ui/core";
const premiumBenefits = [
"Our uncensored AI art generator has everything you could want. Enjoy rocket-like generation speed and everything is super easy to use. What are you still worried about? Come and use the free AI generator to satisfy all your desires about uncensored AI image."];
const premiumBenefits2 = [
  "We guarantee 100% privacy safety, ensuring that your personal information and creations remain completely confidential. Our systems are secured to the highest standards, allowing you to generate uncensored ai art as you wish with total peace of mind."];
  
  

const cardStyle = {
  display: 'flex',
  position:"relative",
  flexDirection: 'column',
  alignItems: 'center',
  width: '220px',
  margin: '2px',
  transition: 'transform 0.2s, border 0.2s',
  borderRadius: '10px', // Add this line to set border radius
};

const cardMediaStyle = {
  height: 'auto',
  width: 'atuo',
  position: 'relative',
  transition: 'transform 0.2s',
};


function HeroSection4(props) {
  const [isHovered, setHovered] = useState(false);


  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container  style={{padding:"0px 0px"}}>
       
      <Box sx={{ flexDirection: { xs: 'column-reverse',lg: 'row' } }} style={{ display: 'flex', justifyContent: 'space-between', gap:"20px" }}>
           {/* left side */}

      <Grid container xs={12} lg={6}   >
      <Grid item  xs={12} lg={12}>
      <Card
            style={{
              position:"relative",
              textAlign: "center",
              maxHeight:"750px"

            }}
          >
            <img
              src="homePage/fastAndSecImage.png"
              alt="Manga"
              style={{ width: "100%",height:"100%", objectFit: "cover" }}
            />
          </Card>
</Grid>
</Grid>

       {/* right side */}
       <Grid container xs={12} lg={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',               
 }}> 
  <Box>

    <Box
  id="right"
  sx={{
    display: { xs: "flex", sm: "flex", md: "flex" },justifyContent: "space-between",
    flexDirection: "column-reverse",
  }}
>
        


            <Box
            sx={{
              flexDirection: "column",
            }}
          > <Typography variant="h3"  style={{fontWeight:"500", fontFamily:" Chakra Petch, sans-serif",fontSize:"30px"}} >
Fast, Stable, High-quality Uncensoed AI Art Generator</Typography>
            
            <Box>



 <Box  sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px"

                }}
              >
                {/* Premium Benefits List */}
                {premiumBenefits.map((benefit, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      flexDirection: "row",

                    }}

                  >
                  
                  <Typography
                      variant="body2"

                      sx={{
                        color: "white",
                        fontSize: "sm",
                        fontWeight: "medium",
                        lineHeight: "tight", 
                        
                      }}
                      style={{fontFamily:"Chakra Petch, sans-serif",fontSize:"18px",padding: "6px",
                    
                    }}
                    >
                      {benefit}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
            <Box style={{display:"flex", justifyContent:"flex-start",gap:"10px"}}>
       <Button  component={Link}
        to="/pricing" variant="contained" style={{background:"#6600FF",color:"white"}}>Checkout Our Plans</Button>
{/* <Button variant="outlined">Learn More</Button> */}
       </Box>
          </Box>
          <Box
            sx={{
              display:{sm:"none",lg:"block"},
              position:"relative",
              textAlign: "center",
            }}
          >
            <img
              src="homePage/fastSectImage.png"
              alt="Manga"
              style={{ width: "65%",minWidth:"300px",objectFit: "cover" }}
            />
          </Box>
         </Box>
  </Box>
  </Grid>
  </Box>






      
  <Box marginTop={10} sx={{ flexDirection: { xs: 'column-reverse',lg: 'row-reverse' } }} style={{ display: 'flex', justifyContent: 'space-between',  padding:"10px 0px"}}>
           {/* left side */}

           <Grid container xs={12} lg={6} style={{ alignItems: 'center', justifyContent: 'center' }}>
      <Grid item xs={12} lg={12}>
        <Card
          style={{
            position: 'relative',
            textAlign: 'center',
            height: 'auto',
            maxWidth: '500px',
            marginLeft: 'auto',  // Horizontally center the card
            marginRight: 'auto', // Horizontally center the card
          }}
        >
          <CardContent>
            <img
              src="homePage/privacySectionImage.png"
              alt="Manga"
              style={{ width: "100%",minWidth:"300px",
               height: '100%', objectFit: 'cover' }}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
       {/* right side */}
       <Grid container xs={12} lg={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',  borderRadius: 8,
 }}> 
  <Box  
>

  
    <Box
  id="right"
  sx={{
    display: { xs: "flex", sm: "flex", md: "flex" },justifyContent: "space-around",
    flexDirection: "column",
    
  }}
>
          <Box
            sx={{
              flexDirection: "column",
              gap: "6px",
            }}
          >
            <Box>
 <Box  sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  borderRadius:"0px 20px 0px 20px",  maxWidth:"100%"

                }}
              >
                
<Typography variant="h3"  style={{fontWeight:"500", fontFamily:" Chakra Petch, sans-serif",fontSize:"30px"}} >
Ensuring Your Privacy Is Our Top Priority
</Typography>
                {/* Premium Benefits List */}
                {premiumBenefits2.map((benefit, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      flexDirection: "row",

                    }}

                  >
                  
                   
                  <Typography
                      variant="body2"

                      sx={{
                        color: "white",
                        fontSize: "sm",
                        fontWeight: "medium",
                        lineHeight: "tight", 
                        
                      }}
                      style={{fontFamily:"Chakra Petch, sans-serif",fontSize:"18px",padding: "6px",
                    
                    }}
                    >
                      {benefit}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
            <Box style={{display:"flex", justifyContent:"flex-start",gap:"10px"}}>
       {/* <Button variant="contained" style={{background:"#6600FF",color:"white"}}>Try Now</Button> */}
<Button  component={Link}
        to="/legal/privacy-policy" variant="outlined">Learn More</Button>
       </Box>
          </Box>
          <Box
            sx={{
              display:{sm:"none",lg:"block"},
              position:"relative",
              textAlign: "center",
              marginBottom: "6px",
              marginTop: "6px",

            }}
          >
            <img
              src="homePage/privacyImage.png"
              alt="Manga"
              style={{ width: "65%",maxWidth:"300px",minWidth:"300px", objectFit: "cover" }}
            />
          </Box>
         </Box>
  </Box>
  </Grid>
  </Box>
      </Container>
    </Section>
  );
}

export default HeroSection4;


